// import React from 'react';

// export default function ListWisata() {
//   return (
//     <div className="flex flex-col mb-[15%]">
//       <div className="flex justify-between items-center mb-[22px] md:px-[5%] lg:px-0">
//         <p className="text-black md:text-2xl text-xl font-bold">Wisata Alam</p>
//         <a href="#" className="text-primary">
//           Lihat Semua {'>'}
//         </a>
//       </div>
//       <div className="grid grid-cols-2 lg:grid-cols-4 justify-items-center gap-8">
//         <div>
//           <img src="/assets/images/image-2.png" alt="image-2" />
//           <p className="md:text-xl text-base font-bold md:mt-5 md:mb-2 mt-3">Wisata Guciku</p>
//           <p className="md:text-sm text-xs text-[#999999]">Lorem ipsum</p>
//           <div className="flex items-center mt-2">
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//           </div>
//         </div>
//         <div>
//           <img src="/assets/images/image-2.png" alt="image-2" />
//           <p className="md:text-xl text-base font-bold md:mt-5 md:mb-2 mt-3">Wisata Guciku</p>
//           <p className="md:text-sm text-xs text-[#999999]">Lorem ipsum</p>
//           <div className="flex items-center mt-2">
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//           </div>
//         </div>
//         <div>
//           <img src="/assets/images/image-2.png" alt="image-2" />
//           <p className="md:text-xl text-base font-bold md:mt-5 md:mb-2 mt-3">Wisata Guciku</p>
//           <p className="md:text-sm text-xs text-[#999999]">Lorem ipsum</p>
//           <div className="flex items-center mt-2">
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//           </div>
//         </div>
//         <div>
//           <img src="/assets/images/image-2.png" alt="image-2" />
//           <p className="md:text-xl text-base font-bold md:mt-5 md:mb-2 mt-3">Wisata Guciku</p>
//           <p className="md:text-sm text-xs text-[#999999]">Lorem ipsum</p>
//           <div className="flex items-center mt-2">
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from 'react';

export default function ListWisata(props) {
  return (
    <div className="flex flex-col mb-[15%]">
      <div className="flex justify-between items-center mb-[22px]">
        <p className="text-black md:text-2xl text-xl font-bold">{props.object}</p>
        <a href="#" className="text-primary">
          Lihat Semua {'>'}
        </a>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 justify-items-center gap-8">
        {props.data.length > 0 ? (
          <>
            {props.data.map((e) => (
              <div className="border-[0.5px] border-[#DDDDDD] rounded" key={e.imgId}>
                <img src={e.image} alt="image-2" className="w-[260px] h-[235px] bg-cover" />
                <div className="p-4">
                  <p className="md:text-xl text-base font-bold md:mt-5 md:mb-2 mt-3">{e.title}</p>
                  <p className="md:text-sm text-xs text-[#999999]">{e.address}</p>
                  <div className="flex items-center mt-2">
                    <img src="/assets/images/star.svg" alt="star" className="w-max" />
                    <img src="/assets/images/star.svg" alt="star" className="w-max" />
                    {/* <Star value={4.8} width={35} height={35} spacing={4} /> */}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : null}
      </div>
    </div>
  );
}
